export const companiesSelector = ({
                                        companies: {
                                          companies,
                                        },
                                      }) => companies;